import {Tag} from '@hconnect/common/components/Tag'
import {Box} from '@mui/material'
import {EventTaskChecklists} from '@widgets/hroc-checklists'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {useTaskChecklists} from '../hooks'
import {HProduceTaskIdentifiers, TaskSource} from '../types'

type Props = {
  task: HProduceTaskIdentifiers
}

export const TaskChecklistsContainer = ({task}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const translate = (key: string) => t(key)
  const isCockpitTask = task?.source === TaskSource.COCKPIT
  const isProcessWorkOrderTask = task?.source === TaskSource.PROCESS_WORK_ORDER

  const isProcessWorkOrderOrCockPitTask = isProcessWorkOrderTask || isCockpitTask

  const isTaskChecklistsEnabled = task && isProcessWorkOrderOrCockPitTask
  const {data: taskChecklists = [], isLoading: isInitialLoadingChecklists} = useTaskChecklists(
    task,
    {
      enabled: isTaskChecklistsEnabled
    }
  )

  if (!isTaskChecklistsEnabled) {
    return null
  }

  return (
    <Box sx={{my: 1.5}} data-test-id="task-checklists">
      <Tag label={translate('shiftEvent.label.safetyChecklists')}>
        <EventTaskChecklists
          checklists={taskChecklists}
          isLoading={isInitialLoadingChecklists}
          plantId={task.plantId}
        />
      </Tag>
    </Box>
  )
}
